import { validator } from '@ally/validator';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '../../../../constants';
import { isHoliday, isWeekend } from '../../../../utils';
dayjs.extend(utc);
dayjs.extend(timezone);
var IsNotWeekendOrHoliday = function (date, _a) {
    var federalHolidays = _a.holidays.federal, transferType = _a.transferType;
    if (transferType !== 'EXTERNAL') {
        return true;
    }
    var deliveryDate = dayjs.tz(date, DATE_PICKER_FORMAT, SERVER_TIMEZONE);
    return !isWeekend(deliveryDate) && !isHoliday(deliveryDate, federalHolidays);
};
export var IsNotWeekendOrHolidayErrorMessage = 'The date you entered is either a weekend or a holiday. Please enter another date.';
export var IsNotWeekendOrHolidayValidator = validator(IsNotWeekendOrHoliday, IsNotWeekendOrHolidayErrorMessage);
//# sourceMappingURL=IsNotWeekendOrHoliday.js.map